import { actionCreator } from '@ardoq/rxbeach';

export const copyUrlWithFiltersDialogOpened = actionCreator(
  '[copyUrlWithFiltersState] COPY_URL_WITH_FILTERS_DIALOG_OPENED'
);

export const copyUrlWithFiltersDialogClosed = actionCreator(
  '[copyUrlWithFiltersState] COPY_URL_WITH_FILTERS_DIALOG_CLOSED'
);

export const generateFiltersStateSucceeded = actionCreator<string>(
  '[copyUrlWithFiltersState] GENERATE_FILTERS_STATE_SUCCEEDED'
);

export const generateFiltersStateFailed = actionCreator(
  '[copyUrlWithFiltersState] GENERATE_FILTERS_STATE_FAILED'
);
